import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { customScrollStyles } from '@gem/ui-kit';

import {
  ISelectContactsPresenter,
  IMyContactsPresenter,
  IExtendedUsersPresenter,
} from '../SelectContacts.types';
import { EmptyComponent } from './EmptyComponent/EmptyComponent';
import { ExtendedUsers } from './ExtendedUsers/ExtendedUsers';
import { MyContacts } from './MyContacts/MyContacts';
import styles from './Users.styles.m.css';

interface IUsersProps {
  selectContactsPresenter: ISelectContactsPresenter;
  myContactsPresenter: IMyContactsPresenter;
  extendedUsersPresenter: IExtendedUsersPresenter;
}

export const Users: FC<IUsersProps> = observer(
  ({ selectContactsPresenter, myContactsPresenter, extendedUsersPresenter }) => {
    if (selectContactsPresenter.noResults) {
      return <EmptyComponent isSearchMode={selectContactsPresenter.isSearchMode} />;
    }

    return (
      <div className={classNames(customScrollStyles.container, styles.scroll)}>
        {extendedUsersPresenter.isShowExtendedUsers ? (
          <ExtendedUsers
            selectContactsPresenter={selectContactsPresenter}
            presenter={extendedUsersPresenter}
          />
        ) : (
          <MyContacts
            selectContactsPresenter={selectContactsPresenter}
            presenter={myContactsPresenter}
          />
        )}
      </div>
    );
  }
);
